import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import FaqItem from '../components/faq';
import Ask from '../components/ask';

const FaqJson = ({ items }) => {
  let questions = [];
  items.forEach(
    ({ node: { questions: q } }) => (questions = questions.concat(
      q.map(({ question, answer_rich: { json: answer } }) => FaqItem.JSONLD({ question, answer })),
    )),
  );

  const jsonld = [
    {
      '@context': 'https://schema.org',
      '@type': 'FAQPage',
      mainEntity: questions,
    },
  ];
  return jsonld;
};

const Faq = ({ items, contacts: { address, phone, email } }) => (
  <div className="row flex-wrap">
    <div className="col-xs-12 col-sm-8 content">
      <div className="title-group">
        <h1 className="title-1">FAQ</h1>
      </div>
      <section className="section accordion">
        {items.map(({ node: { id: groupId, title, questions } }) => (
          <Fragment key={groupId}>
            <h2 className="title-2" style={{ marginTop: '60px' }}>
              {title}
            </h2>
            {questions.map(({ id, question, answer_rich: { json: answer } }) => (
              <FaqItem key={id} question={question} answer={answer} />
            ))}
          </Fragment>
        ))}
      </section>
    </div>
    <div className="col-xs-12 col-sm-4 sidebar">
      <div className="box-container">
        <Ask />
      </div>
      <div className="box-container">
        <div className="box-title">Контакты</div>
        <div className="box-content">
          <ul className="contacts-list">
            <li className="contacts-item address">{address}</li>
            <li className="contacts-item email">
              <a className="contacts-link" href={`mailto:${email}`}>
                {email}
              </a>
            </li>
            <li className="contacts-item phone">
              <a className="contacts-link" href={`tel:${phone}`}>
                {phone}
              </a>
            </li>
          </ul>
        </div>
      </div>
      <div className="box-container">
        <div className="box-content">
          <div id="yandex_rtb_R-A-599273-4"></div>
          <script
            id="gatsby-plugin-yandex-direct"
            key={`gatsby-plugin-yandex-direct`}
            dangerouslySetInnerHTML={{
              __html: `(function(w, d, n, s, t) {
                          w[n] = w[n] || [];
                          w[n].push(function() {
                              Ya.Context.AdvManager.render({
                                  blockId: "R-A-599273-4",
                                  renderTo: "yandex_rtb_R-A-599273-4",
                                  async: true
                              });
                          });
                          t = d.getElementsByTagName("script")[0];
                          s = d.createElement("script");
                          s.type = "text/javascript";
                          s.src = "//an.yandex.ru/system/context.js";
                          s.async = true;
                          t.parentNode.insertBefore(s, t);
                      })(this, this.document, "yandexContextAsyncCallbacks");`
            }}
          />
        </div>
      </div>
    </div >
  </div >
);

Faq.JSONLD = FaqJson;

Faq.propTypes = {
  contacts: PropTypes.shape({
    instagram: PropTypes.string.isRequired,
    facebook: PropTypes.string.isRequired,
    vk: PropTypes.string.isRequired,
    email: PropTypes.string.isRequired,
    phone: PropTypes.string.isRequired,
  }).isRequired,
  items: PropTypes.arrayOf(PropTypes.shape).isRequired,
};

export default Faq;
